import AbstractDecimalAmount from "./AbstractDecimalAmount";

class DecimalForGlobals extends AbstractDecimalAmount {
  static decimales = 2;

  static make(number) {
    return new this(number, DecimalForGlobals.decimales)
  }
}

export default DecimalForGlobals;